import React from 'react';
import Header from '../../../components/ui/Header';

const LoadingSkeleton = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-blue-900 to-purple-900">
      <Header />
      <main className="container mx-auto px-6 py-8 max-w-4xl">
        {/* Breadcrumb Skeleton */}
        <div className="flex items-center space-x-2 mb-6">
          <div className="h-4 bg-white bg-opacity-20 rounded w-24 animate-pulse"></div>
          <div className="h-4 bg-white bg-opacity-10 rounded w-4 animate-pulse"></div>
          <div className="h-4 bg-white bg-opacity-20 rounded w-32 animate-pulse"></div>
        </div>

        {/* Badge Header Skeleton */}
        <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-8 mb-6">
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-6">
              <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full animate-pulse"></div>
              <div>
                <div className="h-8 bg-white bg-opacity-20 rounded-lg w-64 mb-2 animate-pulse"></div>
                <div className="h-6 bg-white bg-opacity-10 rounded-lg w-96 mb-4 animate-pulse"></div>
                <div className="flex space-x-6">
                  <div className="h-6 bg-white bg-opacity-10 rounded w-20 animate-pulse"></div>
                  <div className="h-6 bg-white bg-opacity-10 rounded w-16 animate-pulse"></div>
                  <div className="h-6 bg-white bg-opacity-10 rounded w-24 animate-pulse"></div>
                </div>
              </div>
            </div>
            <div className="flex space-x-3">
              <div className="h-10 w-16 bg-white bg-opacity-20 rounded-lg animate-pulse"></div>
              <div className="h-10 w-20 bg-white bg-opacity-20 rounded-lg animate-pulse"></div>
              <div className="h-10 w-16 bg-white bg-opacity-20 rounded-lg animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Statistics Skeleton */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {[1, 2, 3]?.map((index) => (
            <div
              key={index}
              className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-6"
            >
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-6 h-6 bg-white bg-opacity-20 rounded animate-pulse"></div>
                <div className="h-5 bg-white bg-opacity-20 rounded w-24 animate-pulse"></div>
              </div>
              <div className="h-8 bg-white bg-opacity-20 rounded w-16 mb-1 animate-pulse"></div>
              <div className="h-4 bg-white bg-opacity-10 rounded w-32 animate-pulse"></div>
            </div>
          ))}
        </div>

        {/* Assigned Users Skeleton */}
        <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-8">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-6 h-6 bg-white bg-opacity-20 rounded animate-pulse"></div>
            <div className="h-6 bg-white bg-opacity-20 rounded w-48 animate-pulse"></div>
          </div>

          <div className="space-y-4">
            {[1, 2, 3, 4]?.map((index) => (
              <div key={index} className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white bg-opacity-20 rounded-full animate-pulse"></div>
                  <div>
                    <div className="h-4 bg-white bg-opacity-20 rounded w-32 mb-1 animate-pulse"></div>
                    <div className="h-3 bg-white bg-opacity-10 rounded w-24 animate-pulse"></div>
                  </div>
                </div>
                <div className="h-4 bg-white bg-opacity-10 rounded w-20 animate-pulse"></div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoadingSkeleton;